import { createRouter, createWebHistory } from "vue-router";
import crm_router from "./CRM.js";
import web_router from "./Web.js";

const routes = [...web_router, ...crm_router];

const router = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      if (
        from.name != to.name &&
        to.name == "property" &&
        from.name != undefined
      ) {
        setTimeout(() => {
          resolve({
            top: 0,
            el: "#ProductImages",
            behavior: "instant",
          });
        }, 250);
      } else if (
        from.name == "property" &&
        to.name == "real-estate" &&
        savedPosition
      ) {
        resolve({ top: savedPosition.top, behavior: "instant" });
      } else if (from.name != to.name && from.name != undefined) {
        resolve({ top: 0, behavior: "instant" });
      } else if (from.name == to.name && to.name == "property") {
        let obj = {
          behavior: "instant",
        };

        if (from.params.propertyID != to.params.propertyID) {
          obj.el = "#ProductImages";
          obj.top = 0;
        } else if (to.hash != null && to.hash != "") {
          obj.el = to.hash;
          obj.top = 100;
        }
        setTimeout(() => {
          resolve(obj);
        }, 250);
      } else {
        let data = {};
        if (to.hash) {
          data.el = to.hash;
        } else {
          data.top = 0;
        }
        resolve(data);
      }
    });
  },
});

export default router;
